const rankingItems = [
  { id: 1, rank: 1, title: '心动频率', type: '恋爱', score: '9.8', readers: '386万', change: 'up' },
  { id: 2, rank: 2, title: '剑与魔法', type: '奇幻', score: '9.7', readers: '352万', change: 'same' },
  { id: 3, rank: 3, title: '第七个夜晚', type: '悬疑', score: '9.6', readers: '298万', change: 'up' },
  { id: 4, rank: 4, title: '她的反击', type: '励志', score: '9.5', readers: '267万', change: 'down' },
  { id: 5, rank: 5, title: '樱花季的约定', type: '校园', score: '9.4', readers: '241万', change: 'up' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            人气排行
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-[560px] mx-auto">
            综合热度、评分和读者数生成的本周韩漫人气榜单
          </p>
        </div>

        <div className="max-w-[800px] mx-auto">
          <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
            {rankingItems.map((item, index) => (
              <a
                key={item.id}
                href="#ranking"
                onClick={(e) => e.preventDefault()}
                className={`flex items-center gap-3 md:gap-5 px-5 md:px-8 py-4 md:py-5 transition-colors cursor-pointer ${
                  index < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
                } hover:bg-background-50`}
              >
                <div className="flex items-center justify-center w-8 h-8 rounded-lg flex-shrink-0"
                  style={{
                    backgroundColor:
                      item.rank === 1 ? 'oklch(var(--primary-500))' :
                      item.rank === 2 ? 'oklch(var(--accent-500))' :
                      item.rank === 3 ? 'oklch(var(--secondary-500))' :
                      'oklch(var(--foreground-400))'
                  }}
                >
                  <span className="text-sm font-bold text-background-50">{item.rank}</span>
                </div>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">{item.title}</h3>
                    <span className="inline-flex px-2 py-0.5 text-[10px] font-medium rounded-full whitespace-nowrap"
                      style={{
                        backgroundColor: `oklch(var(--accent-100) / 0.6)`,
                        color: 'oklch(var(--accent-700))'
                      }}
                    >
                      {item.type}
                    </span>
                  </div>
                  <p className="text-xs text-foreground-500 mt-0.5">{item.readers} 人阅读</p>
                </div>

                <div className="flex items-center gap-4 flex-shrink-0">
                  <div className="flex items-center gap-1">
                    <i className="ri-star-fill text-accent-500 text-sm"></i>
                    <span className="text-sm font-semibold text-foreground-900">{item.score}</span>
                  </div>
                  <div className="w-6 h-6 flex items-center justify-center">
                    {item.change === 'up' && <i className="ri-arrow-up-fill text-green-500"></i>}
                    {item.change === 'down' && <i className="ri-arrow-down-fill text-red-400"></i>}
                    {item.change === 'same' && <span className="text-foreground-400 text-xs">—</span>}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}